import { AlertCircle, Loader2, RotateCw } from "lucide-react";

import { mensajeDeError } from "../../lib/api";
import { Button } from "./Button";
import { cn } from "./cn";

/**
 * Estados de carga y error de una pantalla o sección (base:
 * `features/contabilidad/componentes.tsx`, generalizado).
 *
 *   if (q.isPending) return <Cargando />;
 *   if (q.isError) return <ErrorCarga error={q.error} onReintentar={() => q.refetch()} />;
 *
 * `Cargando` se anuncia con role="status" (lectores de pantalla lo leen
 * sin interrumpir); `ErrorCarga` con role="alert".
 */
interface CargandoProps {
  /** Texto visible. Default "Cargando…". */
  texto?: string | undefined;
  /** `inline` para dentro de una tarjeta o fila (sin padding vertical grande). */
  inline?: boolean | undefined;
  className?: string | undefined;
}

export function Cargando({
  texto = "Cargando…",
  inline = false,
  className,
}: CargandoProps): JSX.Element {
  return (
    <div
      role="status"
      className={cn(
        "flex items-center gap-2 text-sm text-neutral-600",
        inline ? "py-2" : "justify-center py-10",
        className,
      )}
    >
      <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
      {texto}
    </div>
  );
}

interface ErrorCargaProps {
  /** El error de la query. Sólo se muestra el mensaje del backend (4xx);
   *  sin red o con 5xx va `mensaje` con qué hacer (`mensajeDeError`). */
  error?: unknown;
  /** Mensaje cuando `error` no trae uno legible. */
  mensaje?: string | undefined;
  /** Si viene, muestra el botón "Reintentar". */
  onReintentar?: (() => void) | undefined;
  className?: string | undefined;
}

export function ErrorCarga({
  error,
  mensaje = "No se pudo cargar la información.",
  onReintentar,
  className,
}: ErrorCargaProps): JSX.Element {
  const texto = mensajeDeError(error, mensaje);
  return (
    <div
      role="alert"
      className={cn(
        "flex flex-wrap items-start gap-2 rounded-md bg-rose-50 px-3 py-2 text-sm text-rose-700 ring-1 ring-rose-200",
        className,
      )}
    >
      <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <span className="min-w-0 flex-1">{texto}</span>
      {onReintentar && (
        <Button variant="secondary" size="sm" icon={RotateCw} onClick={onReintentar}>
          Reintentar
        </Button>
      )}
    </div>
  );
}
